import api from './api/api';

export const getAllMunicipiosByUf = (uf) => {
  return api().get(`/publico/municipios/findByCodigoEstado/${uf}`);
}
export const getEstados = () => {
  return api().get(`/publico/municipios/estados`);
}
